import { render } from "./OrganismoDetalleServicios.vue?vue&type=template&id=a40f9a5e&ts=true"
import script from "./OrganismoDetalleServicios.vue?vue&type=script&lang=ts"
export * from "./OrganismoDetalleServicios.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__